import { render, staticRenderFns } from "./ContactDialog.vue?vue&type=template&id=4d1815ea&scoped=true&"
import script from "./ContactDialog.vue?vue&type=script&lang=js&"
export * from "./ContactDialog.vue?vue&type=script&lang=js&"
import style0 from "./ContactDialog.vue?vue&type=style&index=0&id=4d1815ea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d1815ea",
  null
  
)

export default component.exports